import { render, staticRenderFns } from "./DepartmentPage.vue?vue&type=template&id=7ac99e4c&scoped=true&"
import script from "./DepartmentPage.vue?vue&type=script&lang=js&"
export * from "./DepartmentPage.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentPage.vue?vue&type=style&index=0&id=7ac99e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac99e4c",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/department_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fdepartment%2FDepartmentPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports